import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Hash, DollarSign, Lock } from 'lucide-react';
interface ReferenceModalProps {
  onSubmit: (reference: string, amount: number) => void;
}
export function ReferenceModal({
  onSubmit
}: ReferenceModalProps) {
  const [reference, setReference] = useState('');
  const [amount, setAmount] = useState('');
  const canSubmit = reference.trim().length >= 4 && Number(amount) > 0;
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!canSubmit) return;
    onSubmit(reference.trim(), Number(amount));
  };
  return <div className="fixed inset-0 z-[80] flex items-center justify-center p-4 bg-[#1a2332]/60 backdrop-blur-sm" data-id="element-853">
      <motion.div initial={{
      opacity: 0,
      scale: 0.95,
      y: 10
    }} animate={{
      opacity: 1,
      scale: 1,
      y: 0
    }} transition={{
      duration: 0.2
    }} className="w-full max-w-md bg-white rounded-2xl shadow-2xl overflow-hidden" data-id="element-854">
        <div className="px-6 pt-6 pb-4 border-b border-gray-100" data-id="element-855">
          <h2 className="text-xl font-bold text-brand-navy" data-id="element-856">
            Continue your payment
          </h2>
          <p className="text-sm text-brand-muted mt-1" data-id="element-857">
            Enter the reference number from your agent and the amount you'd like
            to pay.
          </p>
        </div>

        <form onSubmit={handleSubmit} className="px-6 py-5 space-y-4" data-id="element-858">
          <div data-id="element-859">
            <label htmlFor="ref" className="block text-[11px] font-bold tracking-wider text-brand-muted uppercase mb-1.5" data-id="element-860">
              Reference Number*
            </label>
            <div className="relative" data-id="element-861">
              <Hash size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-brand-muted" data-id="element-862" />
              <input id="ref" type="text" value={reference} onChange={e => setReference(e.target.value)} placeholder="e.g. CRG-A7K2-9F4Q" className="w-full pl-9 pr-3 py-2.5 border border-gray-300 rounded-lg text-sm text-brand-dark focus:border-brand-navy focus:outline-none focus:ring-1 focus:ring-brand-navy transition-colors" autoFocus data-id="element-863" />
            </div>
          </div>

          <div data-id="element-864">
            <label htmlFor="amount" className="block text-[11px] font-bold tracking-wider text-brand-muted uppercase mb-1.5" data-id="element-865">
              Balance to Pay*
            </label>
            <div className="relative" data-id="element-866">
              <DollarSign size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-brand-muted" data-id="element-867" />
              <input id="amount" type="number" min={1} step="0.01" value={amount} onChange={e => setAmount(e.target.value)} placeholder="0.00" className="w-full pl-9 pr-3 py-2.5 border border-gray-300 rounded-lg text-sm text-brand-dark focus:border-brand-navy focus:outline-none focus:ring-1 focus:ring-brand-navy transition-colors" data-id="element-868" />
            </div>
            <p className="text-xs text-brand-muted mt-1.5" data-id="element-869">
              Enter the amount your agent confirmed with you.
            </p>
          </div>

          <button type="submit" disabled={!canSubmit} className={`w-full py-3 rounded-lg font-bold text-sm transition-colors mt-2 ${canSubmit ? 'bg-brand-red hover:bg-red-800 text-white shadow-sm' : 'bg-gray-200 text-gray-400 cursor-not-allowed'}`} data-id="element-870">
            Continue to Payment
          </button>

          <p className="text-[11px] text-brand-muted flex items-center justify-center gap-1.5" data-id="element-871">
            <Lock size={11} className="text-green-600" data-id="element-872" />
            Secure encrypted session
          </p>
        </form>
      </motion.div>
    </div>;
}